import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import { brand } from "@/config/brand";
import auth from "@/locales/en/auth.json";
import common from "@/locales/en/common.json";
import ai from "@/locales/en/domains/ai/index.json";
import audit from "@/locales/en/domains/audit.json";
import builder from "@/locales/en/domains/builder.json";
import discovery from "@/locales/en/domains/discovery.json";
import platformAdmin from "@/locales/en/domains/platform-admin.json";
import posture from "@/locales/en/domains/posture.json";
import projects from "@/locales/en/domains/projects/index.json";
import review from "@/locales/en/domains/review.json";
import settings from "@/locales/en/domains/settings/index.json";
import tenantAdmin from "@/locales/en/domains/tenant-admin.json";
import vocabulary from "@/locales/en/vocabulary.json";

export const DEFAULT_NAMESPACE = "common";

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: "en",
    defaultNS: DEFAULT_NAMESPACE,
    // `brandName` is sourced from brand.json (via src/config/brand.ts) so
    // locale strings like "common:appName" ("{{brandName}} Console") never
    // need to hardcode the product name themselves.
    interpolation: { escapeValue: false, defaultVariables: { brandName: brand.name } },
    resources: {
      en: {
        common,
        review,
        posture,
        projects,
        audit,
        builder,
        ai,
        tenantAdmin,
        platformAdmin,
        vocabulary,
        auth,
        discovery,
        settings,
      },
    },
  });

export default i18n;
